import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const lines = ["Capital that", "goes the", "distance."];

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yBg = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const yText = useTransform(scrollYProgress, [0, 1], ["0%", "-12%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section id="hero" ref={ref} className="relative min-h-screen flex items-end overflow-hidden hero-glow" data-testid="hero-section">
      <motion.div
        style={{ y: yBg }}
        className="absolute inset-0"
        aria-hidden
      >
        <img
          src="https://static.prod-images.emergentagent.com/jobs/7ad6febd-76b7-4ae8-88ea-7738fdc731d1/images/a0b103016661637141df41b3fe686a57cc54fb6f7d7f4b54ad1c402aeafbdd09.jpeg"
          alt=""
          className="w-full h-[120%] object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/25 to-transparent" aria-hidden />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/55 to-transparent" aria-hidden />

      <motion.div style={{ y: yText, opacity }} className="relative z-10 max-w-screen-2xl mx-auto px-6 md:px-12 w-full pb-24 pt-40">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="font-mono-tech text-[10px] sm:text-[11px] tracking-[0.22em] sm:tracking-[0.3em] uppercase text-[#e65c00] mb-8 sm:mb-10"
          data-testid="hero-overline"
        >
          Nomad Capital — Private Investment Firm
        </motion.p>

        <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl xl:text-[5.5rem] leading-[1.02] tracking-tight" data-testid="hero-headline">
          {lines.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay: 0.5 + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
              >
                {i === 2 ? <span className="text-[#e65c00]">{line}</span> : line}
              </motion.span>
            </span>
          ))}
        </h1>

        <div className="mt-14 grid md:grid-cols-12 gap-8 items-end">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.15, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6 text-base md:text-lg text-[#a8a8a8] leading-relaxed max-w-xl"
            data-testid="hero-subheadline"
          >
            We partner with founders and owner-operators building enduring
            businesses across pharmaceutical, healthcare, and outdoor
            markets — where necessity, innovation, and durable demand converge.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.3, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6 flex md:justify-end"
          >
            <button
              onClick={() => window.__lenis?.scrollTo(document.getElementById("thesis"), { offset: -20 })}
              className="group w-full sm:w-auto justify-center flex items-center gap-4 font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#f2f0eb] border border-white/15 px-7 py-4 hover:border-[#e65c00] transition-colors duration-300"
              data-testid="hero-cta-button"
            >
              Explore Our Thesis
              <span className="text-[#e65c00] transition-transform duration-300 group-hover:translate-x-1.5">→</span>
            </button>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#555]"
        aria-hidden
      >
        Scroll
      </motion.div>
    </section>
  );
};

export default Hero;
